<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><div class="chapter"><a id="page_2"></a><a id="p9000f15f9970002001">
</a><a id="p9000f15f9960002001">
</a><div class="media-group"><img alt="" src="images/p9000f15fg2001.png" width="81.66969%"/></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?521523fc